(function () {
  const second = 1000,
    minute = second * 60,
    hour = minute * 60,
    day = hour * 24;

  //I'm adding this section so I don't have to keep updating this pen every year :-)
  //remove this if you don't need it
  let today = new Date(),
    dd = String(today.getDate()).padStart(2, "0"),
    mm = String(today.getMonth() + 1).padStart(2, "0"),
    yyyy = today.getFullYear(),
    nextYear = yyyy + 1,
    dayMonth = "12/31/",
    birthday = dayMonth + yyyy;

  today = mm + "/" + dd + "/" + yyyy;
  if (today > birthday) {
    birthday = dayMonth + nextYear;
  }
  //end

  // Check if the element with id "countdown" exists
  var countdownDiv = document.getElementById("countdown");

  const countDown = new Date(birthday).getTime();
  if (countdownDiv !== null) {
    console.log("#countdown exists in the DOM");
    const x = setInterval(function () {
      const now = new Date().getTime(),
        distance = countDown - now;

      (document.getElementById("days").innerText = Math.floor(distance / day)),
        (document.getElementById("hours").innerText = Math.floor(
          (distance % day) / hour
        )),
        (document.getElementById("minutes").innerText = Math.floor(
          (distance % hour) / minute
        )),
        (document.getElementById("seconds").innerText = Math.floor(
          (distance % minute) / second
        ));

      //do something later when date is reached
      if (distance < 0) {
        document.getElementById("headline").innerText = "Giveaway Ends!";
        document.getElementById("countdown").style.display = "none";
        document.getElementById("content").style.display = "block";
        clearInterval(x);
      }
      //seconds
    }, 0);
  }
})();

$().ready(function(){
  $('.slick-carousel').slick({
    arrows: true,
    dots: true,
    slidesToShow: 3,
    infinite: true,
    centerMode: true,

     responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
         {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          autoplay: true,
        }
      },
       ]
  });
  $('.slick-carousel-24').slick({
    arrows: true,
    dots: false,
    slidesToShow: 4.3,
    infinite: true,
    centerMode: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToScroll: 3,
    pauseOnHover:true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3.3,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
         {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          autoplay: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          // centerPadding: '100px',
          slidesToShow: 1,
        }
      }
    ]
  });
});


$(document).ready(function(){
  $('.slick-carousel-video').slick({
    arrows: true,
    dots: true,
    slidesToShow: 3,
    infinite: true,

     responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
         {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          autoplay: true,
        }
      },
       ]
  });
});

$(document).ready(function(){
  $('.video-slideshow-section .video-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: true,
      pauseOnHover: false,
      autoplaySpeed: 5000,
  });
});

// Contact page contact form start
$(document).ready(function () {
  var $typeSelect = $('.custom-dropdown');

  $typeSelect.on('change', function () {
    var selectedValue = $(this).val();

    // Set the attribute based on the selected value
    $(this).closest('.form-control-opetion').attr('opetionvalue', selectedValue);

    // Remove existing budget block
    $('.select-label-text-main').remove();

    // Only add budget field if "Sales inquiry" is selected
    if (selectedValue === 'Sales inquiry') {
      var budgetHTML = `
        <div class="select-label-text-main">
        <div class="select-label-text">Budget</div>
        <div class="form-control-select budget">
          <select class="select select--native is-floating" name="contact[Budget]" required>
            <option value="Unsure">Unsure</option>
            <option value="$0 - $1000">$0 - $1000</option>
            <option value="$1000 - $2500">$1000 - $2500</option>
            <option value="$2500 - $5000">$2500 - $5000</option>
            <option value="$5000 - $10000">$5000 - $10000</option>
            <option value="$10000+">$10000+</option>
          </select>
          <div class="custom-contact-form-select-icon">
            <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1.5L4 4.5L7 1.5" stroke="#121212" stroke-width="2"></path>
            </svg>
          </div>
        </div>
        </div>
      `;

      // Append inside the correct parent
      $(this).closest('.custom-contact-form-select-text').append(budgetHTML);
    }

    // Handle message for "Order tracking/adjustment"
    const $messageContainer = $('.form-control-select-order');
    $messageContainer.empty();

    if (selectedValue === 'Order tracking/adjustment' || selectedValue === 'Order problem') {
      const messageText = `Please refrain from submitting multiple tickets for the same issue, as this can further delay our response time.`;

      const inputHTML = `
        <textarea readonly rows="3" name="contact[order]" style="width: 100%;">${messageText}</textarea>
      `;
      $messageContainer.append(inputHTML);
    }
  });
});
// Contact page contact form end

// $(document).on('click', '.contact-form-button .btn', function () {

//   // Check every 200ms if the success note appears
//   var checkNote = setInterval(function () {
//       console.log('top----------------click');
//     if ($('.note.note--success').length > 0) {
//       // Scroll to top
//       $('html, body').animate({ scrollTop: 0 }, 'slow');
//       console.log('top----------------');

//       // Stop checking
//       clearInterval(checkNote);
//     }
//   }, 200);

//   // Safety stop after 5 seconds
//   setTimeout(function () {
//     clearInterval(checkNote);
//   }, 5000);
// });

$(document).ready(function () {
  // Instant check on page load (normal form submission)
    console.log('Scrolled to top after success message (page)');
  if ($('.note.note--success').length > 0) {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
    console.log('Scrolled to top after success message (page load)');
  }

  // Interval check for dynamically added success message (AJAX)
  var checkNote = setInterval(function () {
    if ($('.note.note--success').length > 0) {
      $('html, body').animate({ scrollTop: 0 }, 'slow');
      console.log('Scrolled to top after success message (AJAX)');
      clearInterval(checkNote);
    }
  }, 1000);

  // Optional: stop checking after 5 seconds
  setTimeout(function () {
    clearInterval(checkNote);
  }, 5000);
});


function set_default_menu() {
  var menu_li = $(".mega-menu");
  $(menu_li).each(function () {
    var menu_image = $(this).find(".collection_image_menu");
    $(menu_image[0]).addClass("first_menu")
    var menu_image_url = $(menu_image).data("menu-image");
    var decodedUrl = decodeURIComponent(menu_image_url);
    var menu_image_div = $(menu_image).parents("div.grid__item").closest("div.grid").find(".menu_image_div");
    $(menu_image_div).empty();
    var e = `<img src="${decodedUrl}" alt="Menu Image">`;
    $(menu_image_div).append(e);
  });
}
$(document).ready(function () {
  $("div.image_menu_li").parent().siblings("div.h5").css("padding-left", "16px");
  if ($('.menu_image_div').is(':empty')) {
  }
});

$(document).on("mouseover", ".collection_image_menu", function () {
  var menu_image = $(this).data("menu-image");
  console.log("menu_image" , menu_image)
  $(this).removeClass("first_menu")
  var decodedUrl = decodeURIComponent(menu_image);
  var menu_image_div = $(this).parents("div.grid__item").closest("div.grid").find(".menu_image_div");
  $(menu_image_div).empty();
  var e = `<img src="${decodedUrl}" alt="Menu Image">`;
  $(menu_image_div).append(e);
});
$(document).on("mouseleave", ".collection_image_menu", function () {
  var menu_image_div = $(this).parents("div.grid__item").closest("div.grid").find(".menu_image_div");
  $(menu_image_div).empty();
});

$(".mobile-nav__item.mobile-nav_item_dropdown").click(function(){
  var data_id = $(this).attr("data-id");
  console.log("data_id------------------" , data_id);
  var data_div = $('.drawer_panel.drawer_panel-next').find(`#${data_id}`);
  $(data_div).addClass("active");
  $('.drawer_panel.drawer_panel-next').css({
    "visibility": "visible",
    "opacity": "1",
    "transform": "translateX(0)"
  });

  let sub_menu_open = $(data_div).find('.mobile-nav__sublist');

  // already-open-menu
  if($(sub_menu_open).hasClass('already-open-menu'))
  {
    console.log("check already open menu");  
    $(sub_menu_open).find('.mobile-nav__link--button').addClass("is-open");
    $(sub_menu_open).find('.mobile-nav__sublist.collapsible-content').addClass("is-open");
    $(sub_menu_open).find('.mobile-nav__sublist.collapsible-content').css({"height": "auto"});
  }
  else
  {
    $('.mobile-nav__link--button').removeClass("is-open");
    $('.mobile-nav__sublist .mobile-nav__sublist.collapsible-content').removeClass("is-open");
    $('.mobile-nav__sublist .mobile-nav__sublist.collapsible-content').css({"height": "0"});
  }//else closed

  setTimeout(function () {
    $('.drawer__scrollable.drawer_panel').css("display", "none")
  }, 300);
  $('.drawer__scrollable.drawer_panel').css({
    "visibility": "hidden",
    "opacity": "0",
    "transform": "translateX(-400px)"
  });
});


$(".drawer__back-button").click(function(){
  $('.mobile_nav_child').removeClass("active");
  $('.drawer__scrollable.drawer_panel').css({
    "visibility": "visible",
    "opacity": "1",
    "transform": "translateX(0px)",
    "transition": "0.5s ease-in-out"
  });
  $('.mobile-nav__link--button').removeClass("is-open");
  $('.mobile-nav__sublist .mobile-nav__sublist.collapsible-content').removeClass("is-open");
  $('.mobile-nav__sublist .mobile-nav__sublist.collapsible-content').css({
   
    "height": "0"
   });
  setTimeout(function () {
    $('.drawer__scrollable.drawer_panel').css("display", "block")
  }, 300);
  $('.drawer_panel.drawer_panel-next').css({
    "visibility": "hidden",
    "opacity": "0",
    "transform": "translateX(400px)",
    "transition": "0.5s ease-in-out"
  });
});
$(".drawer__close-button").click(function(){
  $('.drawer_panel.drawer_panel-next').css({
    "visibility": "hidden",
    "opacity": "0",
    "transform": "translateX(400px)",
    "transition": "0.5s ease-in-out"
  });
  $('.drawer__scrollable.drawer_panel').css({
    "visibility": "visible",
    "opacity": "1",
    "transform": "translateX(0px)",
    "transition": "0.5s ease-in-out"
  });
  setTimeout(function () {
    $('.drawer__scrollable.drawer_panel').css("display", "block")
  }, 300);
});


$(".mobile-nav__sublist .mobile-nav__link--button").click(function(){
  var find_div = $(this).closest(".mobile-nav__item");
  console.log("==find_div==============" , find_div)
});

$(document).ready(function () {
    $(document).on('click', '.metafield-rich_text_field ul li', function () {
    if ($(this).has('strong').length) {
      $(this).toggleClass('active');
    }
  });
  
   $(document).on('click', '.accordion-content-v2.accordion-content-features .accordion-read-more', function () {
    $('.accordion-content-v2.accordion-content-features .accordion-text-icon-main .accordion-text-icon ul li').slideDown();
    $(this).hide(); // Hide the button after click
  });
  
  $(document).on('click', '.accordion-content-v2.accordion-content-compatibility .accordion-read-more', function () {
    $('.accordion-content-v2.accordion-content-compatibility .accordion-text-icon-main .accordion-text-icon ul li').slideDown();
    $(this).hide(); // Hide the button after click
  });

  $(document).on('click', '.accordion-content-v2.accordion-content-included .accordion-read-more', function () {
    $('.accordion-content-v2.accordion-content-included .accordion-text-icon-main .accordion-text-icon ul li').slideDown();
    $(this).hide(); // Hide the button after click
  });

  $(document).on('click', '.specification-table .specifications-tabel-content .accordion-read-more', function () {
    $('.specification-table .specifications-tabel-content .metafield-rich_text_field ul').css('display','grid');
    $(this).hide(); // Hide the button after click
  });
  
});

// paypal app text
$(document).ready(function () {
  const target = document.body;

  const observer = new MutationObserver(function () {
    var paypalElement = $('.paypal-text-main');
    if (paypalElement.length) {
      paypalElement.detach();
      $('.paypal-app-text').prepend(paypalElement);
      observer.disconnect(); // Stop observing after moving the element
    }
  });

  observer.observe(target, {
    childList: true,
    subtree: true
  });
});

$(".black_friday_offer_close").click(function(){
  $(".black_friday_offer").hide();
});


$(document).ready(function () {
  // Function to initialize the mobile slider
  function initMobileSlider() {
    var $slider = $('.contentbox-container');
    var $progressBar = $('.progress-bar');
    var $progressLabel = $('.progress-label');

    // Run only if screen width ≤ 575px
    if ($(window).width() <= 575) {
      // Initialize slick only once
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          infinite: true,
          speed: 600,
          appendArrows: $('.content-box3-arrow'),
          adaptiveHeight: false,
           prevArrow: `
            <button type="button" class="slick-prev" aria-label="Previous">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="28" viewBox="0 0 16 28" fill="none">
                <path d="M14.9141 27.1804L1.41406 14.6804L14.4141 0.68042" stroke="#959595" stroke-width="2"/>
              </svg>
            </button>
          `,
          nextArrow: `
            <button type="button" class="slick-next" aria-label="Next">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="28" viewBox="0 0 16 28" fill="none">
                <path d="M0.679199 0.733765L14.1792 13.2338L1.1792 27.2338" stroke="#959595" stroke-width="2"/>
              </svg>
            </button>
          `
        });

        // Progress update on slide change
        $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          var calc = (nextSlide / (slick.slideCount - 1)) * 100;
          $progressBar.css('width', calc + '%').attr('aria-valuenow', calc);
          $progressLabel.text(Math.round(calc) + '% completed');
        });

        // Initial setup (first slide)
        $progressBar.css('width', '0%');
        $progressLabel.text('0% completed');
      }
    } else {
      // Destroy slick when window width > 575px
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
        $progressBar.css('width', '0%');
        $progressLabel.text('');
      }
    }
  }

  // Initialize on load
  initMobileSlider();

  // Recheck on resize
  $(window).on('resize', function () {
    initMobileSlider();
  });
});

//Reseller page complete script start
$(document).ready(function () {
  // Next button click
  $('.contact-button-next').click(function (event) {
    event.preventDefault();

    var currentSection = $(this).closest('.custom-contact-form-tab-filed-input');
    var nextSection = currentSection.next('.custom-contact-form-tab-filed-input');

    // -------------------------------
    // Validation
    // -------------------------------
    var inputs = currentSection.find('.required');
    var isValid = true;

    inputs.each(function () {

      let errorEl = this.nextElementSibling;
      
      if ($(this).attr('type') === 'checkbox') {
        
        let parentElem = this.closest('.checkbox-field');
        errorEl = parentElem.querySelector('.empty-error-message');
        let checkboxes = parentElem.querySelectorAll('input[type="checkbox"]');

        checkboxes.forEach((cb) => {
          cb.addEventListener('change', function () {
            let anyChecked = Array.from(checkboxes).some((c) => c.checked);
            if (anyChecked) {
              checkboxes.forEach((c) => c.classList.remove('required'));
              if (errorEl && errorEl.classList.contains('empty-error-message')) {
                  errorEl.classList.remove('active_error');
              }
            }
            else 
            {
              checkboxes.forEach((c) => c.classList.add('required'));
            }
          });
        });

        let anyChecked1 = Array.from(checkboxes).some((c) => c.checked);
        if(!anyChecked1){
          this.focus();
          isValid = false;
          if (errorEl && errorEl.classList.contains('empty-error-message')) {
            errorEl.classList.add('active_error');
          }
          return false;
        }

      } else if ($(this).attr('type') === 'radio') {
        
        let parentElem = this.closest('.radio-field');
        errorEl = parentElem.querySelector('.empty-error-message');
        let radios = document.querySelectorAll('input[type="radio"]');

        radios.forEach((rb) => {
          rb.addEventListener('change', function () {
            let anyChecked = Array.from(radios).some((c) => c.checked);
            if (anyChecked) {
              radios.forEach((c) => c.classList.remove('required'));
              if (errorEl && errorEl.classList.contains('empty-error-message')) {
                  errorEl.classList.remove('active_error');
              }
            }
            else 
            {
              radios.forEach((c) => c.classList.add('required'));
            }
          });
        });

        let anyChecked1 = Array.from(radios).some((c) => c.checked);
        if(!anyChecked1){
          this.focus();
          isValid = false;
          if (errorEl && errorEl.classList.contains('empty-error-message')) {
            errorEl.classList.add('active_error');
          }
          return false;
        }
        
      } //else closed

      $(this).off("input change").on("input change", function () {
        if (errorEl && errorEl.classList.contains('empty-error-message')) {
            errorEl.classList.remove('active_error');
        }
        $(this).removeClass('error');
      });

      if (!this.value.trim()) {
        this.focus();
        isValid = false;

        if (errorEl && errorEl.classList.contains('empty-error-message')) {
          errorEl.classList.add('active_error');
        }

        if ($(this).attr('type') !== 'checkbox' && $(this).attr('type') !== 'radio') {
            $(this).addClass('error');
        }
        return false; // break each loop
      } 
      else 
      {
        if(isValid)
        {
          if (errorEl && errorEl.classList.contains('empty-error-message')) {
              errorEl.classList.remove('active_error');
          }
          $(this).removeClass('error');
        }
      } // else closed
      
    });

    if (!isValid) return;

    // -------------------------------
    // Switch to next step
    // -------------------------------
    if (nextSection.length) {
      currentSection.removeClass('active');
      nextSection.addClass('active');

      var index = $('.custom-contact-form-tab-filed-input').index(nextSection);

      // Update tab numbers
      if ($('.custom-contact-form-tab-number-main.desktop').is(':visible')) {
        $('.custom-contact-form-tab-number-main.desktop .custom-contact-form-tab-number-text')
            .removeClass('active')
            .eq(index)
            .addClass('active');
      } else {
        $('.custom-contact-form-tab-number-main.mobile .custom-contact-form-number-text .custom-contact-form-tab-number-text')
            .removeClass('active')
            .eq(index)
            .addClass('active');

        $('.custom-contact-form-tab-number-main.mobile .custom-contact-form-tab .custom-contact-form-tab-number-text')
            .removeClass('active')
            .eq(index)
            .addClass('active');
      }

      // -------------------------------
      // Scroll to next tab & focus first input
      // -------------------------------
      let firstInput = nextSection.find('input, select, textarea').first();
      let specific_div = $("#custom-contact-form");

      if (firstInput.length) {
        $('html, body').animate({
            scrollTop: nextSection.offset().top - 50
        }, 100, function () {
            firstInput.focus();
        });
      }
      else
      {
        $('html, body').animate({
            scrollTop: specific_div.offset().top - 50
        }, 100);
      }
    } // outer if closed

    $('.custom-contect-main.active').removeClass('active');
  });

  // Back button click
  $('.contact-button-back').click(function () {
    var currentSection = $(this).closest('.custom-contact-form-tab-filed-input');
    var prevSection = currentSection.prev('.custom-contact-form-tab-filed-input');

    if (prevSection.length) {
      currentSection.removeClass('active');
      prevSection.addClass('active');

      var index = $('.custom-contact-form-tab-filed-input').index(prevSection);

      if ($('.custom-contact-form-tab-number-main.desktop').is(':visible')) {
        // Desktop
        $('.custom-contact-form-tab-number-main.desktop .custom-contact-form-tab-number-text').removeClass('active').eq(index).addClass('active');

          
        // Get the text of the currently active tab
        var tabText = $('.custom-contact-form-tab-number-text.active').find('.custom-contact-form-tab-text').first().text().trim();
        // Example: do something based on active tab
        if (tabText === 'Company Information') {
            $('.custom-contect-main').addClass('active');
        }

      } else {
        // Mobile
        $('.custom-contact-form-tab-number-main.mobile .custom-contact-form-number-text .custom-contact-form-tab-number-text').removeClass('active').eq(index).addClass('active');
        $('.custom-contact-form-tab-number-main.mobile .custom-contact-form-tab .custom-contact-form-tab-number-text').removeClass('active').eq(index).addClass('active');
          // Get the text of the currently active tab
         var tabText = $('.custom-contact-form-tab-number-main.mobile .custom-contact-form-tab-number-text.active').find('.custom-contact-form-tab-text').first().text().trim();
          // Example: do something based on active tab
          if (tabText === 'Company Information') {
              $('.custom-contect-main').addClass('active');
          }
      }

      let prevFirstInput = prevSection.find('input, select, textarea').first();
      let specific_div = $("#custom-contact-form");

      if (prevFirstInput.length) {
        $('html, body').animate({
            scrollTop: prevSection.offset().top - 50
        }, 100, function () {
            prevFirstInput.focus();
        });
      }
      else
      {
        $('html, body').animate({
            scrollTop: specific_div.offset().top - 50
        }, 100);
      }

    }// if closed
  });

  // Add new input dynamically
  $(document).on('click', '.contact-input-add-text', function (e) {
    e.preventDefault();

    $(".contact-input-add").append(
      `<div class="contact-required">
        <input
          type="text"
          class="input-full required"
          name="contact[company_website]"
          placeholder="https://"
        >
        <button class="remove-btn" value="Remove">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 4L20 20" stroke="black" stroke-width="1.5" stroke-linecap="round"></path>
            <path d="M4 20L20 4" stroke="black" stroke-width="1.5" stroke-linecap="round"></path>
          </svg>
        </button>
      </div>`
    );
  });

  // Remove input
  $(document).on('click', '.remove-btn', function (e) {
    e.preventDefault();
    $(this).closest('.contact-required').remove();
  });

 function hideIntroIfSuccess() {
    if ($('.custom-contact-form-posted-success.active').length) {
      $('.custom-contect-main, .custom-contact-main').removeClass('active');
    }
  }

  // 1. Run once on page load
  hideIntroIfSuccess();

  // 2. Run again when the button is clicked
  $(document).on('click', '.submit-application-button', function() {
    hideIntroIfSuccess();
  });

});
//Reseller page complete script end

// cart page edit opetion sold product start
function checkAndSetAvailability(GPO_Data, intervalId) {
  if ($(GPO_Data).length === 0) {
    return;
  }
  clearInterval(intervalId);
  $(".gpo-form__group .gpo-label").append('<span class="availability" style="display:none;"></span>');
  $('<p class="eta_msg" style="display:none;"></p>').insertAfter(".gpo-form__group .gpo-label");

  $('.gpo-swatches.image-swatches').each(function () {
    const $input = $(this).find("input");
    const productHandle = $input.attr("gpo-data-product-handle");
    const productVarId = $input.attr("gpo-data-variant-id");

    if (productHandle !== "" && productHandle !== undefined) {
      getProductAvailability(productHandle, productVarId);
    }
  });
}

let productPageGPO_1 = '';
// Product Page GPO
if ($("body.template-product .product-section").length !== 0) {
  productPageGPO_1 = ".page-content--product .gpo-swatches.image-swatches";
}

if (productPageGPO_1 !== "") {
  let findGPO = setInterval(function () {
    checkAndSetAvailability(productPageGPO_1, findGPO);
  }, 100);

  setTimeout(function () {
    clearInterval(findGPO);
  }, 50000);
}

if ($(".template-cart .page-content").length) {

  let GPOAddClass = setInterval(function () {
    if ($(".cart .gpo-editCart").length) {
      clearInterval(GPOAddClass);
      $(".cart .gpo-editCart").addClass("gpoEditBTN");
      $(".cart .gpo-editCart.gpoEditBTN").click(function () {
        var checkinputs = setInterval(function () {
          productPageGPO_1 = ".gpo-cartPopup .gpo-swatches.image-swatches";
          if ($(productPageGPO_1).length) {
            $('.gpo-popupBox').addClass('gpo-loading');
            let findGPOData = setInterval(function () {
              checkAndSetAvailability(productPageGPO_1, findGPOData);
            }, 100);

            setTimeout(function () {
              clearInterval(findGPOData);
            }, 50000);
            clearInterval(checkinputs);

          }
        }, 100);
      });
    }
  }, 100);
  // function getProductAvailability(p_Handle, p_variant) {
  // const product_url = p_variant !== "" ? `${location.origin}/products/${p_Handle}?variant=${p_variant}&view=product_availability_data` : `${location.origin}/products/${p_Handle}?view=product_availability_data`;
  // console.log("product_url == ", product_url);
  // }

function getProductAvailability(p_Handle, p_variant) {
  var product_url = p_variant !== "" 
    ? `${location.origin}/products/${p_Handle}?variant=${p_variant}&view=product_availability_data_upsell` 
    : `${location.origin}/products/${p_Handle}?view=product_availability_data_upsell`;

  var only_url = p_variant !== "" 
    ? `${location.origin}/products/${p_Handle}?variant=${p_variant}` 
    : `${location.origin}/products/${p_Handle}`;

  console.log("Product URL:", product_url);
  console.log("Only URL:", only_url);

  $.ajax({
    url: product_url,
    type: "GET",
    success: function (data) {
      // Remove any previous apiData container
      $("body .apiData").remove();
      $("body").append(`<div class="apiData hide"></div>`);
      $(data).appendTo(".apiData");

      // Variables
      var Product_Availability = "";
      var Product_restock = "";
      var Product_eta = "";
      var $productElement = $(`[gpo-data-product-handle="${p_Handle}"]`);
      var Product_link = $(".apiData .Product_link").text();
      Product_restock = $(".apiData .product-info__inventory span").data("stock");

      // Log all variables
      console.log("Product Element:", $productElement);
      console.log("Product Link:", Product_link);
      console.log("Product Restock Status:", Product_restock);
      console.log("Product Availability:", Product_Availability);
      console.log("Product ETA:", Product_eta);
      // Append the Product_restock text to each swatch
     $(".gpo-swatches.image-swatches").each(function() {
  const $swatch = $(this);
  const handle = $swatch.find("input").attr("gpo-data-product-handle");

  // Remove previously added availability spans
  $swatch.find(".availability").remove();

  // Check if this swatch's handle matches Product_restock handle
  if (handle === p_Handle) {
    // Append stock status dynamically
    let statusText = Product_restock || "Sold Out"; // default to Sold Out if undefined
    $swatch.append('<span class="availability ' + statusText.replace(/\s/g,'').toLowerCase() + '" style="display: none;">' + statusText + '</span>');

    // Optional: Add class to main div if sold out
    if (statusText.toLowerCase() === "sold out") {
      $swatch.addClass("sold_out_main_div");
      $swatch.find("input").prop("disabled", true);
    }
  }
});
      // Update swatch availability
      if (Product_restock == "In-Stock") {
        $(`span[data-handle="${p_Handle}"]`).addClass("instock").text(Product_restock);
      } else if (Product_restock == "Pre-Order") {
        $(`span[data-handle="${p_Handle}"]`).addClass("preorder").text(Product_restock);
      } else {
        $(`span[data-handle="${p_Handle}"]`).addClass("outofstock").text(Product_restock);
      }

      if (Product_restock == "Sold Out") {
        $("#test_box_" + p_Handle).closest(".gpo-swatches.image-swatches").addClass("sold_out_main_div");
      }

      // Clean up
      $("body .apiData").remove();
    },
    error: function (error) {
      console.error("Error fetching product information:", error);

      // Hide link and disable swatch
      var $url = $(`[href="${only_url}"]`);
      $url.hide();

      var $swatch = $(`#test_box_${p_Handle}`).closest(".gpo-swatches");
      $swatch.css("pointer-events", "none");
      $(`#test_box_${p_Handle}`).prop("disabled", true);
    },
  });
}
  setTimeout(function () {
    clearInterval(GPOAddClass);
  }, 10000);
}
// cart page edit opetion sold product end
